exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Social-container-desktop {\n  display: flex;\n  width: 100px;\n  justify-content: space-around;\n  align-items: center; }\n\n.Social-item {\n  display: flex;\n  justify-content: center; }\n\n.Social-container-mobile {\n  display: flex;\n  flex-direction: column;\n  align-content: space-between;\n  height: 23%;\n  justify-content: space-between; }\n\n@media screen and (orientation: landscape) and (max-width: 812px) {\n  .Social-container-mobile {\n    height: 60%;\n    justify-content: space-evenly; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Navigation/Social.scss
// module id = 101
// module chunks = 0